module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (176).26f14989.jpg";